var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      ref: "theMenuItem",
      class: _vm.bemBlockMod({
        secondary: _vm.isSecondaryLevel,
        fixed: _vm.isFixed,
        highlight: _vm.isHighlight,
        complex: _vm.hasComplexSubCategories,
        "complex-child": _vm.isComplexChild,
        block: _vm.isBlockCategory,
        "parent-block": _vm.isParentBlockCategory,
        "with-separator": _vm.withSeparator
      }),
      style: _vm.cssCustomProps
    },
    [
      _c(
        "a",
        {
          class: [
            _vm.bemElement("link", {
              selected: _vm.itemSelected || _vm.isCurrentSubmenuOpen,
              highlight: _vm.isHighlight,
              secondary: _vm.isSecondaryLevel,
              block: _vm.isParentBlockCategory,
              "with-separator": _vm.withSeparator,
              "remove-uppercase": _vm.removeUppercase
            }),
            _vm.category.classSpecial
          ],
          attrs: { "data-byl-categoryId": _vm.category.id, href: _vm.href },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.handleClick($event)
            },
            mouseenter: function($event) {
              _vm.isPointerDesktop &&
                !_vm.isSecondaryLevel &&
                !_vm.isCurrentSubmenuOpen &&
                _vm.handleOpenSubmenu()
            }
          }
        },
        [
          _c("span", { class: _vm.bemElement("label") }, [
            _c("span", { class: _vm.bemElement("name") }, [
              _vm._v("\n        " + _vm._s(_vm.category.name) + "\n      ")
            ]),
            _vm._v(" "),
            _vm.customTag
              ? _c(
                  "span",
                  { class: _vm.bemElement("tag"), style: _vm.customTagStyle },
                  [_vm._v("\n        " + _vm._s(_vm.customTag) + "\n      ")]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.subCategories
        ? _c("TheMenuSubmenu", {
            ref: "theMenuSubmenu",
            attrs: {
              categories: _vm.subCategories,
              "has-complex-sub-categories": _vm.hasComplexSubCategories,
              "is-open": _vm.isCurrentSubmenuOpen,
              "is-complex-submenu-child": _vm.isComplexChild,
              "is-parent-block-category": _vm.isBlockCategory,
              "complex-position":
                _vm.hasComplexSubCategories && _vm.itemPosition
            },
            on: { "menu:close-submenu": _vm.handleCloseSubmenu }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }